<template>
  <div id="intergenerational-family-journey-app-container" class="container intergenerational-family-journey-app-container">
    <header>
      <div class="logo"><img :src="baseurl + 'assets/images/fex-logo.svg'" alt="Family Enterprise Foundation" class="logo"  /></div><!-- @click="goToIntro()" -->
      
      <h1>Intergenerational<br>Succession Journey Map</h1>

      <div :class=" (menu ? 'open ' : '') + 'menu'">
        <div v-if="!isActiveTab('intro')" class="handle" @click=" (menu ? menu = 0 : menu = 1) ">
          <span class="text">MENU</span>
          <span class="line1"></span>
          <span class="line2"></span>
          <span class="line3"></span>
        </div>
        <div class="select-path" v-if="!isActiveTab('intro')">
          <!--p>Select your path</p-->
          <h3>Camp 1</h3>
          <!--a @click="setCamp(1); setPath(path);" :class="camp == 1 ? 'c1 active' : 'c1'">Camp 1</a><br /-->
          <a @click="setCamp(1); setPath(1); menu = 0;" :class="camp == 1 && path == 1 ? 'family active' : 'family'">Family</a>
          <a @click="setCamp(1); setPath(2); menu = 0;" :class="camp == 1 && path == 2 ? 'business active' : 'business'">Business</a>
          <a @click="setCamp(1); setPath(3); menu = 0;" :class="camp == 1 && path == 3 ? 'ownership active' : 'ownership'">Ownership</a>
          <br /><br />
          <h3>Camp 2</h3>
          <!--a @click="setCamp(2); setPath(path);" :class="camp == 2 ? 'c2 active' : 'c2'">Camp 2</a><br /-->
          <a @click="setCamp(2); setPath(1); menu = 0;" :class="camp == 2 && path == 1 ? 'family active' : 'family'">Family</a>
          <a @click="setCamp(2); setPath(2); menu = 0;" :class="camp == 2 && path == 2 ? 'business active' : 'business'">Business</a>
          <a @click="setCamp(2); setPath(3); menu = 0;" :class="camp == 2 && path == 3 ? 'ownership active' : 'ownership'">Ownership</a>
        </div>
      </div>
    </header>

    <div id="background-video">
      <vimeo-player 
        ref="player" 
        :video-id="vimeoId" 
        @ready="vimeoOnReady"
        @cuepoint="vimeoOnCuepoint"
      ></vimeo-player><!--:options="options"-->
      
      <div v-if="(introEnd > 0) && showQuestionnaire" id="introEnd" class="overlay">
          
          <h1 id="camp1-title" @click="goToCamp(1, path)">Camp Gen 1</h1>
          <h1 id="camp2-title" @click="goToCamp(2, path)">Camp Gen 2</h1> 
          <h1 id="camp3-title" @click="goToCamp(3, path)">Camp Gen 3</h1>
          <h1 id="camp4-title" @click="goToCamp(4, path)">Camp Gen 4</h1>

          <div id="camp1-nav" @click="goToCamp(1, path)"></div>
          <div id="camp2-nav" @click="goToCamp(2, path)"></div>
          <div id="camp3-nav" @click="goToCamp(3, path)"></div>
          <div id="camp4-nav" @click="goToCamp(4, path)"></div>

          <div id="intro-questionnaire">
            <div class="question" id="intro-questionnaire-question1" v-if="intro_question == 1 || !getAnswer('intro-questionnaire-question1')">
              <h2>Which generation are you in?</h2>
              <ul :class="intro_answer1">
                <li class="gen1" @click="saveAnswer('intro-questionnaire-question1', 'gen1'); setQuestionCamp(1);">1<sup>st</sup> Generation</li>
                <li class="gen2" @click="saveAnswer('intro-questionnaire-question1', 'gen2'); setQuestionCamp(2);">2<sup>nd</sup> Generation</li>
                <li class="gen3" @click="saveAnswer('intro-questionnaire-question1', 'gen3'); setQuestionCamp(2);">3<sup>rd</sup> Generation</li>
                <li class="gen4" @click="saveAnswer('intro-questionnaire-question1', 'gen4'); setQuestionCamp(2);">4<sup>th</sup> + Generation</li>
              </ul>
            </div>

            <div class="question" id="intro-questionnaire-question2" v-if="getAnswer('intro-questionnaire-question1') && intro_question == 2">
              <h2>Which circle do you want to explore first?</h2>
              <ul :class="intro_answer2">
                <li class="family" @click="saveAnswer('intro-questionnaire-question2', 'family'); setPath(1,0);">Family</li>
                <li class="business" @click="saveAnswer('intro-questionnaire-question2', 'business'); setPath(2,0);">Business</li>
                <li class="ownership" @click="saveAnswer('intro-questionnaire-question2', 'ownership'); setPath(3,0);">Ownership</li>
              </ul>
            </div>

            <div class="question" id="intro-questionnaire-question3" v-if="getAnswer('intro-questionnaire-question1') && intro_question == 3">
              <h2>Which transition issue is most pressing for you?</h2>
              <ul :class="intro_answer3">
                <li class="governance" @click="saveAnswer('intro-questionnaire-question3', 'governance'); setStep(2);">Governance</li><!--(Clarifying the Goals and Priorities)-->
                <li class="vision-and-values" @click="saveAnswer('intro-questionnaire-question3', 'vision-and-values'); setStep(3);">Vision and Values</li><!--(Reviewing (or Defining) Strategy)-->
                <li class="leadership" @click="saveAnswer('intro-questionnaire-question3', 'leadership'); setStep(4);">Leadership</li><!--(Planning the Transition of Responsibilities)-->
                <li class="financing-the-transition" @click="saveAnswer('intro-questionnaire-question3', 'financing-the-transition'); setStep(5);">Financing the Transition</li><!--(Transitioning Value)-->
                <li class="not-sure" @click="saveAnswer('intro-questionnaire-question3', 'not-sure'); setStep(1);">Not sure</li><!--(Setting the Table)-->
              </ul>
            </div>

            <ul class="intro-question-nav">
              <li :class="(
                intro_question == 1 ? 
                'current' + (getAnswer('intro-questionnaire-question1') ? ' done ' : '') : 
                (getAnswer('intro-questionnaire-question1') ? ' done ' : '')
              )" @click="setIntroQuestion(1)"><span></span></li>
              <li :class="(
                intro_question == 2 ? 
                'current' + (getAnswer('intro-questionnaire-question2') ? ' done ' : '') : 
                (getAnswer('intro-questionnaire-question2') ? ' done ' : '')
              )" @click="setIntroQuestion(2)"><span></span></li>
              <li :class="(
                intro_question == 3 ? 
                'current' + (getAnswer('intro-questionnaire-question3') ? ' done ' : '') : 
                (getAnswer('intro-questionnaire-question3') ? ' done ' : '')
              )" @click="setIntroQuestion(3)"><span></span></li>
            </ul>

            <a v-if="getAnswer('intro-questionnaire-question1') && getAnswer('intro-questionnaire-question2') && getAnswer('intro-questionnaire-question3') && showQuestionnaire" @click="launch()" id="intro-start">Start</a>
            
            <a v-if="intro_question > 1" @click="previousIntroQuestion()" id="intro-previous"><span><span class="l"></span><span class="r"></span></span></a>
            <a v-if="intro_question < 3" @click="nextIntroQuestion()" id="intro-next"><span><span class="l"></span><span class="r"></span></span></a>

          </div>
      </div>
      
      <!--div v-if="isActiveTab('camp1') && camp1End" id="navCamp1" class="overlay">

        <h1 v-if="step == 0" id="camp1-family-title" @click="setPath(1)">Family</h1>
        <h1 v-if="step == 0" id="camp1-business-title" @click="setPath(2)">Business</h1> 
        <h1 v-if="step == 0" id="camp1-ownership-title" @click="setPath(3)">Ownership</h1>
        
        <div v-if="step == 0" id="camp1-family-step1-nav" @click="setPath(1)"></div>
        <div v-if="step == 0" id="camp1-business-step1-nav" @click="setPath(2)"></div>
        <div v-if="step == 0" id="camp1-ownership-step1-nav" @click="setPath(3)"></div>
        
      </div-->

      <!--div v-if="isActiveTab('camp2')" id="introCamp2" class="overlay">

      </div>

      <div v-if="isActiveTab('camp2') && camp2End" id="navCamp2" class="overlay">

      </div>

      <div v-if="isActiveTab('camp3')" id="introCamp3" class="overlay">

      </div>

      <div v-if="isActiveTab('camp3') && camp3End" id="navCamp3" class="overlay">

      </div>

      <div v-if="isActiveTab('camp4')" id="introCamp4" class="overlay">

      </div>

      <div v-if="isActiveTab('camp4') && camp4End" id="navCamp4" class="overlay">

      </div-->
    </div>
  
    <div v-if="isActiveTab('intro')" class="intro">
      
    </div>
    
    <div v-if="(isActiveTab('camp1') && path > 0 && step > 0 && camp == 1 && (Camp1Path1End || Camp1Path2End || Camp1Path3End))" class="camp1">
      
      <camp1-path1 :step="thestep" :voidPath="voidPath" :vimeoPause="vimeoPause" :vimeoPlay="vimeoPlay" :vimeoGoTo="vimeoGoTo" v-if="Camp1Path1End && camp == 1 && path == 1" />
      <camp1-path2 :step="thestep" :voidPath="voidPath" :vimeoPause="vimeoPause" :vimeoPlay="vimeoPlay" :vimeoGoTo="vimeoGoTo" v-if="Camp1Path2End && camp == 1 && path == 2" />
      <camp1-path3 :step="thestep" :voidPath="voidPath" :vimeoPause="vimeoPause" :vimeoPlay="vimeoPlay" :vimeoGoTo="vimeoGoTo" v-if="Camp1Path3End && camp == 1 && path == 3" />
    </div>
    
    <div v-if="isActiveTab('camp2') && path > 0 && step > 0 && camp == 2 && (Camp2Path1End || Camp2Path2End || Camp2Path3End)" class="camp2">
      <camp2-path1 :step="thestep" :voidPath="voidPath" :vimeoPause="vimeoPause" :vimeoPlay="vimeoPlay" :vimeoGoTo="vimeoGoTo" v-if="Camp2Path1End && camp == 2 && path == 1" />
      <camp2-path2 :step="thestep" :voidPath="voidPath" :vimeoPause="vimeoPause" :vimeoPlay="vimeoPlay" :vimeoGoTo="vimeoGoTo" v-if="Camp2Path2End && camp == 2 && path == 2" />
      <camp2-path3 :step="thestep" :voidPath="voidPath" :vimeoPause="vimeoPause" :vimeoPlay="vimeoPlay" :vimeoGoTo="vimeoGoTo" v-if="Camp2Path3End && camp == 2 && path == 3" />
    </div>

    <div v-if="isActiveTab('camp3') && path" class="camp3">
      camp 3
    </div>

    <div v-if="isActiveTab('camp4') && path" class="camp4">
      camp 4
    </div>

    <a v-if="isActiveTab('intro') && playing" @click="setIntroNav()" id="skip">Start</a>

    <footer :class="credits ? 'open' : ''">
      <div class="credits" @click="toggleCredit()">
        <a id="credits">Credits</a>
        <p>Coming soon...</p>
      </div>
      
      <div class="copy">© Family Enterprise Foundation. All rights reserved. </div>
    </footer>
  </div>
</template>

<script>
//import Camp1Intro from "@/components/Camp1Intro.vue";
import Camp1Path1 from "@/components/Camp1Path1.vue";
import Camp1Path2 from "@/components/Camp1Path2.vue";
import Camp1Path3 from "@/components/Camp1Path3.vue";

import Camp2Path1 from "@/components/Camp2Path1.vue";
import Camp2Path2 from "@/components/Camp2Path2.vue";
import Camp2Path3 from "@/components/Camp2Path3.vue";


function setCookie(name, value, minutes) {
  var expires;
  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

// Read cookie
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

export default{
  name: "intergenerational-app",
  components: {
    //Camp1Intro,
    Camp1Path1,
    Camp1Path2,
    Camp1Path3,
    Camp2Path1,
    Camp2Path2,
    Camp2Path3,
  },
  data() {
    return {
      //vimeoId: 760857237, //760857453,
      //794157002
      vimeoId: 876897276,
      playerReady: 0,
      activeTab: (getCookie('activeTab') ? getCookie('activeTab') : "intro"),
      introEnd: (getCookie('introEnd') ? parseInt(getCookie('introEnd')) : 0),
      Camp1Path1End: (getCookie('Camp1Path1End') ? parseInt(getCookie('Camp1Path1End')) : 0),
      Camp1Path2End: (getCookie('Camp1Path2End') ? parseInt(getCookie('Camp1Path2End')) : 0),
      Camp1Path3End: (getCookie('Camp1Path3End') ? parseInt(getCookie('Camp1Path3End')) : 0),
      Camp2Path1End: (getCookie('Camp2Path1End') ? parseInt(getCookie('Camp2Path1End')) : 0),
      Camp2Path2End: (getCookie('Camp2Path2End') ? parseInt(getCookie('Camp2Path2End')) : 0),
      Camp2Path3End: (getCookie('Camp2Path3End') ? parseInt(getCookie('Camp2Path3End')) : 0),

      credits: 0,
      playing: 0,
      options: {
        autoplay: true,
        background: true,
        muted: true
      },
      camp: (getCookie('camp') ? parseInt(getCookie('camp')) : 1),
      questionCamp: (getCookie('questionCamp') ? parseInt(getCookie('questionCamp')) : 1),
      path: (getCookie('path') ? parseInt(getCookie('path')) : 0), //1 - Family, 2 - Business, 3 - Ownership
      step: (getCookie('step') ? parseInt(getCookie('step')) : 0),
      tile: (getCookie('tile') ? parseInt(getCookie('tile')) : 0),
      intro_question: 1,
      showQuestionnaire: (getCookie('show-questionnaire') ? parseInt(getCookie('show-questionnaire')) : 1),
      intro_answer1: getCookie('intro-questionnaire-question1'),
      intro_answer2: getCookie('intro-questionnaire-question2'),
      intro_answer3: getCookie('intro-questionnaire-question3'),
      menu: 0
    }
  },
  mounted() {

    switch (getCookie('intro-questionnaire-question2')) {
      case 'family':
        this.path = 1; setCookie("path", 1); break;
      case 'business':
        this.path = 2; setCookie("path", 2); break;
      case 'ownership':
        this.path = 3; setCookie("path", 3); break;
    }

    switch (getCookie('intro-questionnaire-question3')) {
      case 'governance':
        this.step = 2; setCookie("step", 2); break;
      case 'vision-and-values':
        this.step = 3; setCookie("step", 3); break;
      case 'leadership':
        this.step = 4; setCookie("step", 4); break;
      case 'financing-the-transition':
        this.step = 5; setCookie("step", 5); break;
      default:
        this.step = 1;  setCookie("step", 1);
    }
    
    if (this.camp && this.path && this.step) {
      setCookie('activeTab', 'camp' + this.camp);
    }

    if (getCookie('activeTab') == 'camp1') {
      switch (this.path) {
        case 1: this.$refs.player.player.setCurrentTime(26); break;
        case 2: this.$refs.player.player.setCurrentTime(89); break;
        case 3: this.$refs.player.player.setCurrentTime(176); break;
      }
    } else if (getCookie('activeTab') == 'camp2') {
      switch (this.path) {
        case 1: this.$refs.player.player.setCurrentTime(250); break;
        case 2: this.$refs.player.player.setCurrentTime(356); break;
        case 3: this.$refs.player.player.setCurrentTime(439); break;
      }

    } 
  },
  computed: {
    thestep() {
      return this.step;
    }
  },
  methods: {
    isActiveTab(dest) {
      return this.activeTab === dest;
    },

    voidPath() {
        this.path = 0;
        setCookie('path', 0);
    },

    setIntroQuestion(iq) {
      if (iq) {
        this.intro_question = iq;
      } else {
        this.intro_question = this.intro_question + 1;
      }
    },

    previousIntroQuestion() {
      this.intro_question = this.intro_question - 1;
    },

    nextIntroQuestion() {
      this.intro_question = this.intro_question + 1;
    },

    hideQuestionnaire() {
      this.showQuestionnaire = 0;
      setCookie('show-questionnaire', 0);
    },

    setPath(p, go = 1) {
      this.path = p;
      this.step = 1;

      setCookie('step', 1);
      setCookie('path', p);

      if (go) {
        this.vimeoGoTo(this.camp, p, this.step);
      }
    },

    setCamp(c) {
      this.camp = c;
      setCookie('camp', c);

      // if (c > 1) {
      //   this.Camp1Path1End = 1;
      //   this.Camp1Path2End = 1;
      //   this.Camp1Path3End = 1;
      // }
    },

    setQuestionCamp(c) {
      this.questionCamp = c;
      setCookie('questionCamp', c);

      // if (c > 1) {
      //   this.Camp1Path1End = 1;
      //   this.Camp1Path2End = 1;
      //   this.Camp1Path3End = 1;
      // }
    },

    setStep(s) {
      this.step = s;

      setCookie('step', s);
    },

    getClass(q, v) {
      if (this.getAnswer(q) == v) {
        return v + ' selected';
      }
      return v;
    },

    goToCamp(c, p) {
      this.activeTab = 'camp' + c;
      this.camp = c;
      this.path = p;
      this.introEnd = 0;

      setCookie('camp', c);
      setCookie('path', p);
      setCookie('activeTab', 'camp' + c);
      setCookie('introEnd', 0);

      // switch(c) {
      //   case 1:
      //     // this.$refs.player.player.setCurrentTime(42);    
      //     // this.$refs.player.pause();
      //     // this.camp1End = 1;
      //     // setCookie('camp1End', 1);
      //     break;
      // }
      
    },

    launch() {
      let self = this;
      self.activeTab = 'camp' + self.camp;
      self.introEnd = 0;

      self.camp = self.questionCamp;

      setCookie('introEnd', 0);
      setCookie('Camp1Path1End', 0);
      setCookie('Camp1Path2End', 0);
      setCookie('Camp1Path3End', 0);
      setCookie('Camp2Path1End', 0);
      setCookie('Camp2Path2End', 0);
      setCookie('Camp2Path3End', 0);
      setCookie('activeTab', 'camp' + self.camp);

      self.hideQuestionnaire(); 

      this.vimeoGoTo(self.camp, self.path, self.step);
      
    },

    saveAnswer(key, value) {
      setCookie(key, value);

      switch (key) {
        case 'intro-questionnaire-question1': 
          this.intro_answer1 = value;
          break;
        case 'intro-questionnaire-question2': 
          this.intro_answer2 = value;
          break;
        case 'intro-questionnaire-question3': 
          this.intro_answer3 = value;
          break;
      }

    },

    getAnswer(key) {
      return getCookie(key);
    },

    goToIntro() {
      this.camp = 1;
      this.step = 0;
      this.tile = 0;
      this.path = 0;
      this.setIntroNav();
      this.activeTab = "intro";

      this.Camp1Path1End = 0;
      this.Camp1Path2End = 0;
      this.Camp1Path3End = 0;
      setCookie('Camp1Path1End', 0);
      setCookie('Camp1Path2End', 0);
      setCookie('Camp1Path3End', 0);

      this.Camp2Path1End = 0;
      this.Camp2Path2End = 0;
      this.Camp2Path3End = 0;
      setCookie('Camp2Path1End', 0);
      setCookie('Camp2Path2End', 0);
      setCookie('Camp2Path3End', 0);

      this.introEnd = 0;
      setCookie('introEnd', 0);
      
      setCookie('camp', 1);
      setCookie('step', 0);
      setCookie('path', 0);
      setCookie('tile', 0);
      setCookie('activeTab', 'intro');
    },

    toggleCredit() {
      if (this.credits) {
        this.credits = 0;
      } else {
        this.credits = 1;
      }
    },

    vimeoOnReady(player) {
      this.playerReady = 1;
      player.addCuePoint(0.1, "playing");
      player.addCuePoint(24, "introEnd");
      
      // player.addCuePoint(26, "camp1FamilyStep1End");
      // player.addCuePoint(29, "camp1FamilyStep2End");
      // player.addCuePoint(36, "camp1FamilyStep3End");
      // player.addCuePoint(43, "camp1FamilyStep4End");
      // player.addCuePoint(49, "camp1FamilyStep5End");
      // player.addCuePoint(58, "camp1FamilyStep6End");
      
      // player.addCuePoint(88, "camp1OwnershipStep1End");
      // player.addCuePoint(93, "camp1OwnershipStep2End");
      // player.addCuePoint(99, "camp1OwnershipStep3End");
      // player.addCuePoint(106, "camp1OwnershipStep4End");
      // player.addCuePoint(113, "camp1OwnershipStep5End");
      // player.addCuePoint(118, "camp1OwnershipStep6End");
      // player.addCuePoint(126, "camp1OwnershipStep7End");

      // player.addCuePoint(175, "camp1BusinessStep1End");
      // player.addCuePoint(184, "camp1BusinessStep2End");
      // player.addCuePoint(207, "camp1BusinessStep3End");
      // player.addCuePoint(216, "camp1BusinessStep4End");
      // player.addCuePoint(225, "camp1BusinessStep5End");
      // player.addCuePoint(242, "camp1BusinessStep6End");

      //player.addCuePoint(249, "camp1BusinessEnd");

      player.addCuePoint(88, "Camp1Path1End");
      player.addCuePoint(176, "Camp1Path3End");
      player.addCuePoint(249, "Camp1Path2End");

      player.addCuePoint(355, "Camp2Path1End");
      player.addCuePoint(438, "Camp2Path2End");
      player.addCuePoint(529, "Camp2Path3End");

    },

    vimeoOnCuepoint(c) {
      
      switch (c.data) {
        case 'playing':
          this.playing = 1;
          setCookie("playing", 1);
          break;

        case 'introEnd':
          this.setIntroNav();
          break;
        
        case 'Camp1Path1End':
          if (!this.Camp1Path1End) {  
            this.Camp1Path1End = 1;
            this.activeTab = 'camp1';
            setCookie("Camp1Path1End", 1);
            this.$refs.player.pause();
          }
          
          break;

        case 'Camp1Path2End':
          if (!this.Camp1Path2End) {  
            this.Camp1Path2End = 1;
            this.activeTab = 'camp1';
            setCookie("Camp1Path2End", 1);
            this.$refs.player.pause();
          }
          break;

        case 'Camp1Path3End':
          if (!this.Camp1Path3End) {  
            this.Camp1Path3End = 1;
            this.activeTab = 'camp1';
            setCookie("Camp1Path3End", 1);
            this.$refs.player.pause();
          }
          break;

        case "camp1FamilyStep1End":
        case "camp1FamilyStep2End":
        case "camp1FamilyStep3End":
        case "camp1FamilyStep4End":
        case "camp1FamilyStep5End":
        case "camp1FamilyStep6End":
          if (this.Camp1Path1End) {
            this.$refs.player.pause();
          }
          break;

        case "camp1OwnershipStep1End":
        case "camp1OwnershipStep2End":
        case "camp1OwnershipStep3End":
        case "camp1OwnershipStep4End":
        case "camp1OwnershipStep5End":
        case "camp1OwnershipStep6End":
        case "camp1OwnershipStep7End":
          if (this.Camp1Path3End) {
            this.$refs.player.pause();
          }
          break;

        case "camp1BusinessStep1End":
        case "camp1BusinessStep2End":
        case "camp1BusinessStep3End":
        case "camp1BusinessStep4End":
        case "camp1BusinessStep5End":
        case "camp1BusinessStep6End":
          if (this.Camp1Path2End) {
            this.$refs.player.pause();
          }
          break;


        case 'Camp2Path1End':
          if (!this.Camp2Path1End) {  
            this.Camp2Path1End = 1;
            this.activeTab = 'camp2';
            setCookie("Camp2Path1End", 1);
            this.$refs.player.pause();
          }
          break;

        case 'Camp2Path2End':
          if (!this.Camp2Path2End) {  
            this.Camp2Path2End = 1;
            this.activeTab = 'camp2';
            setCookie("Camp2Path2End", 1);
            this.$refs.player.pause();
          } 
          break;

        case 'Camp2Path3End':
          if (!this.Camp2Path3End) {  
            this.Camp2Path3End = 1;
            this.activeTab = 'camp2';
            setCookie("Camp2Path3End", 1);
            this.$refs.player.pause();
          }
          break;

        default:
          this.$refs.player.pause();
          break;
      }

    },

    setIntroNav() {
      this.$refs.player.player.setCurrentTime(26);    
      this.$refs.player.pause();
      this.introEnd = 1;
      this.playing = 0;
      setCookie('introEnd', 1);
      setCookie('playing', 0);
    },

    vimeoGoTo(camp, path, step) {
      this.camp = camp;
      this.step = step;
      this.path = path;

      setCookie('camp', camp);
      setCookie('step', step);
      setCookie('path', path);
      
      let time = 0;


      
      switch (camp + '-' + path) {
        case '1-1':
          if (this.Camp1Path1End) { 
            this.$refs.player.mute(); 
          } else {
            this.$refs.player.unmute(); 
          }
          break;
        case '1-2':
          if (this.Camp1Path2End) { 
            this.$refs.player.mute(); 
          } else {
            this.$refs.player.unmute(); 
          }
          break;
        case '1-3':
          if (this.Camp1Path3End) { 
            this.$refs.player.mute(); 
          } else {
            this.$refs.player.unmute(); 
          }
          break;

        case '2-1':
          if (this.Camp2Path1End) { 
            this.$refs.player.mute(); 
          } else {
            this.$refs.player.unmute(); 
          }
          break;
        case '2-2':
          if (this.Camp2Path2End) { 
            this.$refs.player.mute(); 
          } else {
            this.$refs.player.unmute(); 
          }
          break;
        case '2-3':
          if (this.Camp2Path3End) { 
            this.$refs.player.mute(); 
          } else {
            this.$refs.player.unmute(); 
          }
          break;
      }

     
      switch (camp + '-' + path + '-' + step) {
        case '1-1-0': time = 27; break;
        case '1-1-1': time = 27; break;
        case '1-1-2': time = 29.3; break;
        case '1-1-3': time = 36.3; break;
        case '1-1-4': time = 43.3; break;
        case '1-1-5': time = 49.3; break;
        //case '1-1-6': time = 77.5; break;

        case '1-3-0': time = 89; break;
        case '1-3-1': time = 89; break;
        case '1-3-2': time = 93.3; break;
        case '1-3-3': time = 99.3; break;
        case '1-3-4': time = 106.3; break;
        case '1-3-5': time = 113.3; break;
        case '1-3-6': time = 118.3; break;
        case '1-3-7': time = 126.3; break;
        
        case '1-2-0': time = 176; break;
        case '1-2-1': time = 176; break;
        case '1-2-2': time = 184.3; break;
        case '1-2-3': time = 207.3; break;
        case '1-2-4': time = 216.3; break;
        case '1-2-5': time = 225.3; break;
        case '1-2-6': time = 242.3; break;
        
        case '2-1-0':
        case '2-1-1':
        case '2-1-2':
        case '2-1-3':
        case '2-1-4':
        case '2-1-5':
        case '2-1-6': 
          time = 250; break;

        case '2-2-0':
        case '2-2-1':
        case '2-2-2':
        case '2-2-3':
        case '2-2-4':
        case '2-2-5':
        case '2-2-6': 
          time = 356; break;

        case '2-3-0':
        case '2-3-1':
        case '2-3-2':
        case '2-3-3':
        case '2-3-4':
        case '2-3-5':
        case '2-3-6': 
          time = 439; break;
      }

      if (!this.step) {
        this.step = 1;
        step = 1;
      }

      if (this.camp < 3) {
        this.$refs.player.player.setCurrentTime(time);    
        this.$refs.player.play();
      }
    },

    vimeoPause() {
      this.$refs.player.pause();
    },

    vimeoPlay() {
      this.$refs.player.play();
    },
    
    // vimeoStop() {
    //   this.$refs.player.stop();
    // },

    getAnchor() {
      let currentUrl = document.URL;
      let urlParts = currentUrl.split('#');

      if (urlParts.length > 1) {
        let hash = urlParts[1].split("-");
        this.camp = hash[0];
        this.path = hash[1];
        this.step = hash[2];
        this.tile = hash[3];
      }
    }

  }
}
</script>

<style scoped>
 
</style>